import * as React from 'react';

export const CheckboxInline = (props: any) => (
  <div className="row middle-xs ml-10">
    {props.children[0]}
    <span className="ml-5 mr-10">{props.children[1]}</span>
  </div>
);



// WEBPACK FOOTER //
// ./src/common/components/checkbox-inline/checkbox-inline.tsx